__webpack_require__.p = "https://ui.gamma.eu-west-1.urc.advertising.amazon.dev/";